import { graphql, useStaticQuery } from 'gatsby';

export default function BiMenuLinks() {
  const BiMenu = useStaticQuery(graphql`
    query MyBiQuery {
      allMenuLinkContentBi {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return BiMenu;
}
